import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  details: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  status: {
    padding: '20px 40px'
  },
  statusSuccess: {
    background: palette.success.gradient
  },
  paperBody: {
    padding: '0 40px 50px 40px',
    marginTop: '10px'
  },
  detailsTable: {
    marginTop: '20px',
    '& .MuiTableCell-root': {
      padding: '5px 0'
    }
  },
  tenantName: {
    background: palette.brandGradients.fade
  },
  iconWrapper: {
    marginRight: '20px'
  },
  emailRow: {
    display: 'flex',
    width: '100%',
    alignItems: 'center'
  },
  emailWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: '1',
    marginRight: '20px',
    overflow: 'hidden',
    '& .MuiTypography-h6': {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  },
  paperInvite: {
    marginLeft: '10px'
  },
  customAddress: {
    width: '100%'
  },
  customAddressHeader: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiChip-root': {
      marginLeft: '8px'
    },
    '& .MuiTypography-root': {
      maxWidth: '280px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  customAddressBody: {
    padding: '4px',
    fontSize: '13px',
    backgroundColor: palette.info.light,
    margin: '-18px -24px -18px -24px'
  },
  customAddressDetails: {
    paddingRight: '16px'
  },
  customAddressBodyTitle: {
    display: 'flex',
    padding: '8px 20px',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: palette.common.white
  },
  customAddressBodyTitleData: {
    width: '100%',
    paddingRight: '16px',
    '& b': {
      display: 'block',
      fontWeight: '600',
      fontSize: '14px'
    },
    '& span': {
      display: 'block',
      fontSize: '13px',
      color: palette.shades[700]
    }
  },
  customAddressBodyDetails: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 20px',
    justifyContent: 'space-between'
  }
}));
export default useStyles;